import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { ComponentStruct } from "../common/Interfaces";
import CheckBoxListModels from "../components/selectModels_components/CheckBoxListModels";
import SelectModelDescription from "../components/selectModels_components/SelectModelDescription";
import NextButton from "../components/selectModels_components/NextButton";
import "../common/CommonStyle.css";
import EnterDate from "../components/selectModels_components/EnterDate";
import { useModels } from "../api/simDocuments/ModelService";

export default function SelectModel() {
  const location = useLocation();
  const hide: boolean = process.env.REACT_APP_HIDE === "true";
  const modelState = location.state?.modelState;
  const { models, loading: loadingModels } = useModels({
    productCompany: modelState.selectedCompany
      ? modelState.selectedCompany.key
      : "",
    productRange: modelState.selectedProductRange
      ? modelState.selectedProductRange
      : "",
    archived: false,
  });
  const { models: archivedModels, loading: loadingArchivedModels } = useModels({
    productCompany: modelState.selectedCompany
      ? modelState.selectedCompany.key
      : "",
    productRange: modelState.selectedProductRange
      ? modelState.selectedProductRange
      : "",
    archived: true,
  });
  const selectAll = modelState.selectedProductRange !== null;
  const [showArchived, setShowArchived] = useState(false);
  const [selectedModels, setSelectedModels] = useState<ComponentStruct[]>([]);
  const [selectedArchivedModels, setSelectedArchivedModels] = useState<
    ComponentStruct[]
  >([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isStartDateValid, setIsStartDateValid] = useState(false);
  const [disabledNext, setDisabledNext] = useState(true);

  useEffect(() => {
    if (!hide) setShowArchived(models.length === 0);
  }, [models]);

  useEffect(() => {
    if (selectAll && models.length > 0) {
      setSelectedModels(models);
    }
  }, [selectAll, models]);

  const handleDateChange = (
    start: string,
    end: string,
    validity: boolean,
    coherence: boolean
  ) => {
    setStartDate(start);
    setEndDate(end);
    setIsStartDateValid(validity);
    setDisabledNext(!coherence);
  };

  return (
    <>
      <Row>
        <h4>Select Model</h4>
      </Row>
      <Row>
        <Col xs={8}>
          <SelectModelDescription
            modelState={modelState}
            selectedModels={selectedModels}
            selectedArchivedModels={selectedArchivedModels}
          />
          {loadingModels ? (
            <Spinner animation="border" />
          ) : (
            <CheckBoxListModels
              options={models}
              selectAll={selectAll}
              archivedCheckbox={true}
              onChecked={(checked) => {
                setShowArchived(checked);
                if (showArchived) {
                  setSelectedArchivedModels([]);
                }
              }}
              onChange={(selectedItems) =>
                setSelectedModels(selectedItems || [])
              }
            />
          )}
          {loadingArchivedModels ? (
            <Spinner animation="border" />
          ) : (
            <CheckBoxListModels
              options={archivedModels}
              archivedCheckbox={false}
              show={showArchived}
              onChange={(selectedItems) =>
                setSelectedArchivedModels(selectedItems || [])
              }
            />
          )}

          <EnterDate onChange={handleDateChange} />
        </Col>
        <Col xs={5}>{!hide && <Button>Add Feature value Filter</Button>}</Col>
        <NextButton
          modelState={modelState}
          selectedModels={selectedModels}
          selectedArchivedModels={selectedArchivedModels}
          startDate={startDate}
          endDate={endDate}
          isStartDateValid={isStartDateValid}
          disabledNext={disabledNext}
        />
      </Row>
    </>
  );
}
